"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MenuList = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _objectSpread6 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _defaultShouldLoadMore = _interopRequireDefault(require("./default-should-load-more"));

var _defaultReduceOptions = _interopRequireDefault(require("./default-reduce-options"));

var _wrapMenuList = _interopRequireDefault(require("./wrap-menu-list"));

var MenuList = (0, _wrapMenuList["default"])(_reactSelect.components.MenuList);
exports.MenuList = MenuList;

var sleep = function sleep(ms) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, ms);
  });
};

var AsyncPaginateBase = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(AsyncPaginateBase, _Component);

  var _super = (0, _createSuper2["default"])(AsyncPaginateBase);

  function AsyncPaginateBase(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, AsyncPaginateBase);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleScrolledToBottom", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var inputValue, optionsCache, currentOptions;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              inputValue = _this.props.inputValue;
              optionsCache = _this.state.optionsCache;
              currentOptions = optionsCache[inputValue];

              if (!currentOptions) {
                _context.next = 6;
                break;
              }

              _context.next = 6;
              return _this.loadOptions();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    var options = props.options,
        defaultOptions = props.defaultOptions;
    var initialOptions = defaultOptions === true ? null : defaultOptions instanceof Array ? defaultOptions : options;
    var initialOptionsCache = initialOptions ? {
      '': {
        isFirstLoad: false,
        isLoading: false,
        options: initialOptions,
        hasMore: true,
        additional: props.additional
      }
    } : {};
    _this.state = {
      optionsCache: initialOptionsCache
    };
    return _this;
  }

  (0, _createClass2["default"])(AsyncPaginateBase, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var defaultOptions;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                defaultOptions = this.props.defaultOptions;

                if (!(defaultOptions === true)) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return this.loadOptions();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(oldProps) {
        var _this$props, cacheUniq, defaultOptions, inputValue, menuIsOpen;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props = this.props, cacheUniq = _this$props.cacheUniq, defaultOptions = _this$props.defaultOptions, inputValue = _this$props.inputValue, menuIsOpen = _this$props.menuIsOpen;

                if (!(oldProps.cacheUniq !== cacheUniq)) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 4;
                return this.setState({
                  optionsCache: {}
                });

              case 4:
                if (!(defaultOptions === true)) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 7;
                return this.loadOptions();

              case 7:
                _context3.next = 11;
                break;

              case 9:
                if (inputValue !== oldProps.inputValue) {
                  this.handleInputChange(inputValue);
                }

                if (menuIsOpen && !oldProps.menuIsOpen) {
                  this.onMenuOpen();
                }

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "onMenuOpen",
    value: function () {
      var _onMenuOpen = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var loadOptionsOnMenuOpen, optionsCache;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                loadOptionsOnMenuOpen = this.props.loadOptionsOnMenuOpen;
                optionsCache = this.state.optionsCache;

                if (!(!optionsCache[''] && loadOptionsOnMenuOpen)) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 5;
                return this.loadOptions();

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onMenuOpen() {
        return _onMenuOpen.apply(this, arguments);
      }

      return onMenuOpen;
    }()
  }, {
    key: "getInitialCache",
    value: function getInitialCache() {
      var additional = this.props.additional;
      return {
        isFirstLoad: true,
        options: [],
        hasMore: true,
        isLoading: false,
        additional: additional
      };
    }
  }, {
    key: "handleInputChange",
    value: function () {
      var _handleInputChange = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(search) {
        var optionsCache;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                optionsCache = this.state.optionsCache;

                if (optionsCache[search]) {
                  _context5.next = 4;
                  break;
                }

                _context5.next = 4;
                return this.loadOptions();

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function handleInputChange(_x2) {
        return _handleInputChange.apply(this, arguments);
      }

      return handleInputChange;
    }()
  }, {
    key: "loadOptions",
    value: function () {
      var _loadOptions = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var inputValue, optionsCache, currentOptions, debounceTimeout, newInputValue, hasError, additional, options, hasMore, _loadOptions2, response, newAdditional, reduceOptions;

        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                inputValue = this.props.inputValue;
                optionsCache = this.state.optionsCache;
                currentOptions = optionsCache[inputValue] || this.getInitialCache();

                if (!(currentOptions.isLoading || !currentOptions.hasMore)) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt("return");

              case 5:
                _context6.next = 7;
                return this.setState(function (prevState) {
                  return {
                    optionsCache: (0, _objectSpread6["default"])({}, prevState.optionsCache, (0, _defineProperty2["default"])({}, inputValue, (0, _objectSpread6["default"])({}, currentOptions, {
                      isLoading: true
                    })))
                  };
                });

              case 7:
                debounceTimeout = this.props.debounceTimeout;

                if (!(debounceTimeout > 0)) {
                  _context6.next = 16;
                  break;
                }

                _context6.next = 11;
                return sleep(debounceTimeout);

              case 11:
                newInputValue = this.props.inputValue;

                if (!(inputValue !== newInputValue)) {
                  _context6.next = 16;
                  break;
                }

                _context6.next = 15;
                return this.setState(function (prevState) {
                  return {
                    optionsCache: (0, _objectSpread6["default"])({}, prevState.optionsCache, (0, _defineProperty2["default"])({}, inputValue, (0, _objectSpread6["default"])({}, prevState.optionsCache[inputValue], {
                      isLoading: false
                    })))
                  };
                });

              case 15:
                return _context6.abrupt("return");

              case 16:
                _context6.prev = 16;
                _loadOptions2 = this.props.loadOptions;
                _context6.next = 20;
                return _loadOptions2(inputValue, currentOptions.options, currentOptions.additional);

              case 20:
                response = _context6.sent;
                options = response.options;
                hasMore = response.hasMore;
                additional = response.additional;
                hasError = false;
                _context6.next = 30;
                break;

              case 27:
                _context6.prev = 27;
                _context6.t0 = _context6["catch"](16);
                hasError = true;

              case 30:
                if (!hasError) {
                  _context6.next = 35;
                  break;
                }

                _context6.next = 33;
                return this.setState(function (prevState) {
                  return {
                    optionsCache: (0, _objectSpread6["default"])({}, prevState.optionsCache, (0, _defineProperty2["default"])({}, inputValue, (0, _objectSpread6["default"])({}, currentOptions, {
                      isLoading: false
                    })))
                  };
                });

              case 33:
                _context6.next = 39;
                break;

              case 35:
                newAdditional = typeof additional === 'undefined' ? null : additional;
                reduceOptions = this.props.reduceOptions;
                _context6.next = 39;
                return this.setState(function (prevState) {
                  return {
                    optionsCache: (0, _objectSpread6["default"])({}, prevState.optionsCache, (0, _defineProperty2["default"])({}, inputValue, (0, _objectSpread6["default"])({}, currentOptions, {
                      options: reduceOptions(currentOptions.options, options, newAdditional),
                      hasMore: !!hasMore,
                      isLoading: false,
                      isFirstLoad: false,
                      additional: newAdditional
                    })))
                  };
                });

              case 39:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[16, 27]]);
      }));

      function loadOptions() {
        return _loadOptions.apply(this, arguments);
      }

      return loadOptions;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          selectRef = _this$props2.selectRef,
          components = _this$props2.components,
          SelectComponent = _this$props2.SelectComponent,
          inputValue = _this$props2.inputValue,
          props = (0, _objectWithoutProperties2["default"])(_this$props2, ["selectRef", "components", "SelectComponent", "inputValue"]);
      var optionsCache = this.state.optionsCache;
      var currentOptions = optionsCache[inputValue] || this.getInitialCache();
      return /*#__PURE__*/_react["default"].createElement(SelectComponent, (0, _extends2["default"])({}, props, {
        inputValue: inputValue,
        handleScrolledToBottom: this.handleScrolledToBottom,
        isLoading: currentOptions.isLoading,
        isFirstLoad: currentOptions.isFirstLoad,
        options: currentOptions.options,
        components: (0, _objectSpread6["default"])({
          MenuList: MenuList
        }, components),
        ref: selectRef
      }));
    }
  }]);
  return AsyncPaginateBase;
}(_react.Component);

AsyncPaginateBase.propTypes = {
  loadOptions: _propTypes["default"].func.isRequired,
  loadOptionsOnMenuOpen: _propTypes["default"].bool,
  debounceTimeout: _propTypes["default"].number,
  shouldLoadMore: _propTypes["default"].func,
  inputValue: _propTypes["default"].string.isRequired,
  menuIsOpen: _propTypes["default"].bool.isRequired,
  options: _propTypes["default"].arrayOf(_propTypes["default"].object),
  defaultOptions: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].arrayOf(_propTypes["default"].object)]),
  // eslint-disable-next-line react/forbid-prop-types
  additional: _propTypes["default"].any,
  reduceOptions: _propTypes["default"].func,
  SelectComponent: _propTypes["default"].elementType,
  components: _propTypes["default"].objectOf(_propTypes["default"].func),
  filterOption: _propTypes["default"].func,
  onInputChange: _propTypes["default"].func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  cacheUniq: _propTypes["default"].any,
  selectRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])
};
AsyncPaginateBase.defaultProps = {
  debounceTimeout: 0,
  shouldLoadMore: _defaultShouldLoadMore["default"],
  options: null,
  defaultOptions: false,
  additional: null,
  reduceOptions: _defaultReduceOptions["default"],
  SelectComponent: _reactSelect["default"],
  components: {},
  filterOption: null,
  cacheUniq: null,
  selectRef: null,
  loadOptionsOnMenuOpen: true
};
var _default = AsyncPaginateBase;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-select-async-paginate/lib/async-paginate-base.js
// module id = 500
// module chunks = 1